// Environnement dev/qualif : ne touche pas à la console, les logs restent
// utiles pendant le développement.
export function guardConsole(): void {}
